import React from "react";
import { Desktop, Mobile } from "@edreamsodigeo/frontend-core";
import { Body, Flex, Glyph } from "@edreamsodigeo/prisma-design-system";
const ManageBookingsBannerAdvantageItem = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(Flex, {
    gap: "1x_small",
    maxWidth: "360px"
  }, /*#__PURE__*/React.createElement(Desktop, null, /*#__PURE__*/React.createElement(Glyph, {
    category: "UIActions",
    name: "CheckCircle",
    size: "medium",
    color: "green.50",
    sx: {
      minWidth: "24px"
    }
  }), /*#__PURE__*/React.createElement(Body, {
    type: "base",
    color: "neutral.90",
    weight: "normal"
  }, children)), /*#__PURE__*/React.createElement(Mobile, null, /*#__PURE__*/React.createElement(Glyph, {
    category: "UIActions",
    name: "CheckCircle",
    size: "small",
    color: "green.50",
    sx: {
      minWidth: "16px",
      mt: "tiny"
    }
  }), /*#__PURE__*/React.createElement(Body, {
    type: "small",
    color: "neutral.90",
    weight: "normal"
  }, children)));
};
export default ManageBookingsBannerAdvantageItem;